var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1833_67683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 30.7883C18.4189 29.2953 12.4376 24.9534 3 29.5641V10.8141C17.3188 3.81874 23.6812 17.4312 38 10.4359V19.8109",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30L27.75 26.675C27.6724 26.6207 27.6094 26.5502 27.566 26.4692C27.5226 26.3882 27.5 26.2989 27.5 26.2083V23.5833C27.5 23.4286 27.5658 23.2803 27.6831 23.1709C27.8003 23.0615 27.9592 23 28.125 23H36.875C37.0408 23 37.1997 23.0615 37.3169 23.1709C37.4342 23.2803 37.5 23.4286 37.5 23.5833V26.1821C37.4997 26.272 37.4771 26.3607 37.434 26.4411C37.3909 26.5216 37.3285 26.5916 37.2516 26.6458L32.5 30Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30L27.75 33.325C27.6724 33.3793 27.6094 33.4498 27.566 33.5308C27.5226 33.6118 27.5 33.7011 27.5 33.7917V36.4167C27.5 36.5714 27.5658 36.7197 27.6831 36.8291C27.8003 36.9385 27.9592 37 28.125 37H36.875C37.0408 37 37.1997 36.9385 37.3169 36.8291C37.4342 36.7197 37.5 36.5714 37.5 36.4167V33.8179C37.4999 33.7277 37.4775 33.6388 37.4344 33.5581C37.3913 33.4773 37.3287 33.407 37.2516 33.3527L32.5 30Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.75C22.5711 23.75 24.25 22.0711 24.25 20C24.25 17.9289 22.5711 16.25 20.5 16.25C18.4289 16.25 16.75 17.9289 16.75 20C16.75 22.0711 18.4289 23.75 20.5 23.75Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15V22.5",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1833_67683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.149b869b711c6a0b320f13aebd7b1e5d.svg";
export { ForwardRef as ReactComponent };